import { SERVICES } from '@/mocks/home';

export default function Services() {
  return (
    <section id="services" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">What We Do</span>
          <h2 className="mt-3 font-heading text-3xl font-extrabold text-primary-800 md:text-4xl">Our Services</h2>
          <div className="mx-auto mt-4 h-1 w-20 rounded-full bg-accent-500"></div>
        </div>

        <div className="mt-14 flex flex-col gap-16">
          {SERVICES.map((s, i) => (
            <article
              key={s.title}
              className={`grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-14 ${
                i % 2 === 1 ? 'lg:[&>*:first-child]:order-2' : ''
              }`}
            >
              <div className="relative h-64 w-full overflow-hidden rounded-lg border border-background-200 md:h-80">
                <img
                  src={s.image}
                  alt={s.title}
                  title={`${s.title} — Crystal Clean Fort Myers`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div>
                <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-secondary-800">
                  <i className="ri-checkbox-circle-line text-accent-600"></i> Service
                </span>
                <h3 className="mt-4 font-heading text-2xl font-bold text-primary-800 md:text-3xl">{s.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">{s.description}</p>
                <a
                  href="#quote"
                  className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-700 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-800"
                >
                  Read More <i className="ri-arrow-right-line text-[18px]"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}